import React from 'react';

import { ActionsDataProvider } from './ActionsDataProvider';
import { InsightsDataProvider } from './InsightsDataProvider';

export const CliveInsightsProvider: React.FC<React.PropsWithChildren<{ areActionsInConductorHub: boolean }>> = ({
  areActionsInConductorHub,
  children,
}) => {
  return (
    <InsightsDataProvider>
      <ActionsDataProvider isDisabled={areActionsInConductorHub}>{children}</ActionsDataProvider>
    </InsightsDataProvider>
  );
};
